import { aiLaravelData } from "@/mocks/aiSolutionsData";
import AnimatedSection from "@/components/AnimatedSection";

export default function AiLaravelSection() {
  return (
    <section className="py-16 md:py-24 bg-laravel-section relative overflow-hidden">
      <div className="container-astro">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left text */}
          <AnimatedSection>
            <div className="mb-8">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gradient-to-r from-[#2563EB] to-[#7C3AED] text-white text-xs font-semibold">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-code-s-slash-line" />
                </span>
                Laravel + AI
              </span>
              <h2 className="mt-4 text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 font-heading tracking-tight leading-tight">
                {aiLaravelData.heading}
              </h2>
              <div className="w-16 h-1 rounded-full mt-4 bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              {aiLaravelData.subtext}
            </p>
          </AnimatedSection>

          {/* Right cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {aiLaravelData.items.map((item, i) => (
              <AnimatedSection key={item.title} delay={i * 100}>
                <div className="h-full rounded-2xl border border-background-200/80 bg-background-50 p-6 card-lift hover:border-accent-200">
                  <div className="w-11 h-11 rounded-xl bg-secondary-100 text-secondary-700 flex items-center justify-center mb-4">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${item.icon} text-xl`} />
                    </span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-950 font-heading mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}